// extracted by mini-css-extract-plugin
export var root = "BookCover-module--root--H2zha";
export var withShadow = "BookCover-module--withShadow--oqGCF";